document.addEventListener('DOMContentLoaded', function () {
    // the submit button waits for every confirmation on the page: the customer's, and an admin's second one
    const checks = $('#delete_account, #confirm_admin_delete');

    function update() {
        $('.delete_account_submit').attr('disabled', checks.filter(':not(:checked)').length > 0);
    }

    checks.on('change', update);

    if (checks.length) {
        update();
    }
});
